import React from 'react'
import { useMsal } from '@azure/msal-react'
import Button from 'react-bootstrap/Button'

function handleLogout(instance) {
  localStorage.removeItem('msalIdToken')
  localStorage.removeItem('userAuth')
  localStorage.setItem('appLoggedOut', 'true')
  sessionStorage.clear()
  instance.logoutRedirect({ postLogoutRedirectUri: '/' }).catch((e) => {
    console.error(e)
  })
}

/**
 * Renders a button which, when selected, will log out of the app and redirect to '/'
 */
export const SignOutButton = () => {
  const { instance } = useMsal()
  return (
    <Button variant="small" className="ml-auto" onClick={() => handleLogout(instance)}>
      Sign out
    </Button>
  )
}
